const empConst = {
  TIPO_GAS: 'G',
  TIPO_ELE: 'E',
  TIPO_PET: 'P'
};

// Modelo Resumen Cuota
const RESUMEN_CUOTA_INIT = {
  id: null,
  total: 0,
  iva: 0,
  importeIva: 0,
  totalIngresar: 0,
  formaPago: 'C',
  numCuenta: ''
};

export { empConst, RESUMEN_CUOTA_INIT };
